import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import { ActionResult } from '~/models/shared/result'
import RequestBuilder from '~/builders/http/RequestBuilder'

@containerScoped()
export default class DiscountsService {
  constructor(@inject(RequestBuilder) private requestBuilder: RequestBuilder) {}

  disableClassified(classifiedId: number, days: number): Promise<ActionResult> {
    return this.requestBuilder
      .request('delete', `/api/admin/discounts/${classifiedId}/disable/`)
      .data({
        days
      })
      .send()
  }

  disableUser(userId: number, days: number): Promise<ActionResult> {
    return this.requestBuilder
      .request('delete', `/api/admin/discounts/users/${userId}/disable/`)
      .data({
        days
      })
      .send()
  }
}
